import * as yup from 'yup'

export const userValidationSchema = yup.object({
  profile: yup.string().required('Profile is required'),
  cellphone_number: yup.string(),
  identity: yup.object().required('Identity is required').nullable(),
  company: yup
    .mixed()
    .required('Company is required.')
    .test('Check company data type', 'Company is invalid.', (value: any) => {
      if (typeof value !== 'string') {
        if (!(value instanceof Object)) {
          return false
        }
      }
      return true
    }),
})

export const identityValidationSchema = yup.object({
  email: yup.string().email('Identity should be a valid email.').required(),
  name: yup.string().min(3).required(),
  password: yup.string().min(8),
})
